import React from 'react';
import CardBase from './CardBase';

interface CardCustomImageProps {
  title: React.ReactNode;
  image: string;
  badge?: number | string;
  color: string;
  targetUrl?: string;
  openInNewTab?: boolean;
}

const CardCustomImage: React.FC<CardCustomImageProps> = ({ 
  title, 
  image, 
  badge, 
  color, 
  targetUrl,
}) => {

  const imageIcon = <img src={image} className="card-image" alt="" />;

  return (
    <CardBase
      title={title}
      badge={badge}
      icon={imageIcon}
      color={color}
      targetUrl={targetUrl}
    />
  );
};

export default CardCustomImage;